import apiClient from './apiClient'
import { AskAiProvider } from './aiProviderConfig'

export type AskAiChatTurn = {
  role: 'user' | 'assistant'
  content: string
}

export interface ExplainQuestionPayload {
  provider: AskAiProvider
  apiKey: string
  model?: string
  resultId: number
  questionId: number
  paperId: number
  imageDetail?: 'low' | 'high'
  /** Prior chat turns (assistant/user) after the hidden question context */
  chatHistory?: AskAiChatTurn[]
  /** Follow-up user message */
  userMessage?: string
}

export interface ExplainContentPayload {
  provider: AskAiProvider
  apiKey: string
  model?: string
  title: string
  contentHtml: string
  selectedText?: string
  chatHistory?: AskAiChatTurn[]
  userMessage?: string
}

export interface ExplainQuestionResult {
  markdown: string
  model: string
  provider: string
  imageCount: number
  skillSources: string[]
}

export async function explainQuestionWithAi(
  payload: ExplainQuestionPayload
): Promise<ExplainQuestionResult> {
  const response = await apiClient.post('/student/ask-ai/explain-question', payload, {
    timeout: 90000,
  })
  if (!response.data?.success || !response.data?.data?.markdown) {
    throw new Error(response.data?.message || 'Ask AI thất bại')
  }
  return response.data.data as ExplainQuestionResult
}

export async function explainContentWithAi(
  payload: ExplainContentPayload
): Promise<ExplainQuestionResult> {
  const response = await apiClient.post('/student/ask-ai/explain-content', payload, {
    timeout: 90000,
  })
  if (!response.data?.success || !response.data?.data?.markdown) {
    throw new Error(response.data?.message || 'Ask AI thất bại')
  }
  return response.data.data as ExplainQuestionResult
}
